<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">Unit Converter</div>
    </div>

    <div class="white-wrapper mt-5">
      <div class="row">
        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <label></label>
            <b-dropdown
              :text="fromSelectedOption"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Unit"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchUnit()"
                  v-on:keydown="onSearchUnit()"
                  v-on:search="onSearchUnit()"
                  v-model="searchUnit"
                />
              </div>
              <b-dropdown-item
                v-on:click="onSelectFrom(obj)"
                v-for="(obj, objKey) in ms_unit_of_measurement"
                :key="objKey"
                >{{ obj.uom_short_form }}</b-dropdown-item
              >
            </b-dropdown>
            <!-- <b-form-select class="select-curve" :options="fromList" v-model="fromSelectedOption"></b-form-select> -->
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="dropdown-curve-container">
            <b-dropdown
              :text="toSelectedOption"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-on:click="toSelectedFrom(obj)"
                v-for="(obj, objKey) in toList"
                :key="objKey"
                >{{ obj.uom_short_form }}</b-dropdown-item
              >
            </b-dropdown>
            <!-- <b-form-select class="select-curve" :options="toList" v-model="toSelectedOption"></b-form-select> -->
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  v-model="enteredAmount"
                  v-on:input="onConvertHandler($event)"
                />
                <label>Enter Value to be Converted</label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input v-model="totalAmount" placeholder="." disabled />
                <label>Converted Value</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import UnitConverterService from "@/services/UnitConverterService";
export default {
  data() {
    return {
      searchUnit: "",
      ms_unit_of_measurementCopy: [],
      enteredAmount: null,
      totalAmount: "",
      fromSelectedOption: "Select Unit",
      toSelectedOption: "Selected Unit",
      fromList: ["Kilogram", "Gram", "Miligram", "Ounce"],
      toList: [],
      ms_unit_of_measurement: [],
      conversion_formula: "",
      from_uom_id: "",
      to_uom_id: "",
      conversion_operator: ""
    };
  },
  mounted() {
    this.getUnitOfMeasurement();
  },
  methods: {
    onSearchUnit: function() {
      if (this.searchUnit && this.searchUnit.length > 0) {
        this.ms_unit_of_measurement = this.ms_unit_of_measurementCopy.filter(
          x => {
            if (
              x.uom_short_form
                .toLowerCase()
                .includes(this.searchUnit.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.ms_unit_of_measurement = this.ms_unit_of_measurementCopy;
      }
    },
    onConvertHandler: function(event) {
      if (this.conversion_operator == "M") {
        this.totalAmount = (
          this.enteredAmount * parseFloat(this.conversion_formula)
        ).toFixed(2);
      } else if (this.conversion_operator == "D") {
        this.totalAmount = (
          this.enteredAmount / parseFloat(this.conversion_formula)
        ).toFixed(2);
      } else if (this.conversion_operator == "P") {
        this.totalAmount = (
          this.enteredAmount + parseFloat(this.conversion_formula)
        ).toFixed(2);
      } else if (this.conversion_operator == "S") {
        this.totalAmount = (
          this.enteredAmount - parseFloat(this.conversion_formula)
        ).toFixed(2);
      }

      // MY CODE

      // if (
      //   this.fromSelectedOption === "Kilogram" &&
      //   this.toSelectedOption === "Gram"
      // ) {
      //   this.totalAmount = parseInt(this.enteredAmount) * 1000;
      // } else if (
      //   this.fromSelectedOption === "Kilogram" &&
      //   this.toSelectedOption === "Miligram"
      // ) {
      //   this.totalAmount = parseInt(this.enteredAmount) * 1e6;
      // } else if (
      //   this.fromSelectedOption === "Kilogram" &&
      //   this.toSelectedOption === "Ounce"
      // ) {
      //   this.totalAmount = parseInt(this.enteredAmount) * 35.27;
      // } else if (
      //   this.fromSelectedOption === "Kilogram" &&
      //   this.toSelectedOption === "Kilogram"
      // ) {
      //   this.totalAmount = this.enteredAmount;
      // }
    },

    getUnitOfMeasurement: function() {
      let payload = {
        tableName: "ms_unit_of_measurement"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_unit_of_measurement = data.Records;
            this.ms_unit_of_measurementCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectFrom: function(obj) {
      this.searchUnit = "";
      this.onSearchUnit();
      this.fromSelectedOption = obj.uom_short_form;
      this.from_uom_id = obj.uom_id;
      this.toList = [];
      this.to_uom_id = "";
      this.toSelectedOption = "Selected Unit";
      this.getToList(obj.uom_id);
    },
    toSelectedFrom: function(obj) {
      this.toSelectedOption = obj.uom_short_form;
      this.to_uom_id = obj.uom_id;
      this.getConverterFormula();
    },
    getToList: function(uom_id) {
      MasterService.GetUoMTList({ uom_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.toList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getConverterFormula: function() {
      this.enteredAmount = "";
      this.totalAmount = "";
      let payload = {
        conversion_from: this.from_uom_id,
        conversion_to: this.to_uom_id
      };
      UnitConverterService.GetConvertFormula(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            console.log("data.Records :", data.Records);
            if (data.Records.length > 0) {
              this.conversion_operator = data.Records[0].conversion_operator;
              this.conversion_formula = data.Records[0].conversion_formula;
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    }
  }
};

// var from = document.getElementById("from");
// var toConvert = document.getElementById("toConvert");
// var fromWeightType = document.getElementById("fromWeightType");
// var toWeightType = document.getElementById("toWeightType");

// // now add listener

// function toConverting() {
//     toConvert.value = from.value;
// }
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/unitConverterComponents/unitConverter.vue